import React from 'react'
import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom'
import FollowButton from '../Components/FollowButton'
import CollapsingHeader from '../Components/CollapsingHeader'
import SortedFeed, { NotFoundMessage, useSortParam } from '../Components/SortedFeed'
import { useDocumentTitle } from '../Hooks/useDocumentTitle'
import { useFeed } from '../Hooks/useFeed'
import { api } from '../Services/api'
import { useFollow } from '../State/Follow'
import { useCategories, useResource } from '../State/refData'
import { slugify } from '../Utils/text'

/* /tema/{slug} (spec 5.6): no "TEMA" label, "+ Prati" in the header.
   ?newSince= (an "Aktuelna tema" push, spec 9.12) marks the stories since
   then NOVO. */
export default function TopicPage() {
  const { slug } = useParams()
  const location = useLocation()
  const [params] = useSearchParams()
  const newSince = params.get('newSince') || ''
  const [sort, setSort] = useSortParam()
  const { sources: followed } = useFollow()
  const categories = useCategories()
  const canonical = slugify(slug)

  const feed = useFeed(
    `topic:${canonical}:${sort}:${newSince}:${followed.join(',')}`,
    ({ cursor, refresh }) =>
      api.topicStories(canonical, { sort, cursor, followed, refresh, newSince }),
    { enabled: canonical === slug }
  )
  const info = useResource(`topic:${canonical}`, () => api.topic(canonical), {
    enabled: canonical === slug,
  })
  const topic = feed.extra.topic || info.data
  useDocumentTitle(topic?.title || null)

  // Old links: /tema/Rat%20u%20Ukrajini -> /tema/rat-u-ukrajini, /tema/Politika -> /kategorija/politika.
  if (canonical !== slug) return <Navigate to={`/tema/${canonical}`} replace />
  // A topic merged into another (spec 9.7a) answers with that one: go there.
  if (topic?.slug && topic.slug !== canonical)
    return <Navigate to={`/tema/${topic.slug}${location.search}`} replace />
  const missing = feed.status === 'error' && feed.error?.response?.status === 404
  if (missing && categories.some((c) => c.slug === canonical))
    return <Navigate to={`/kategorija/${canonical}`} replace />

  const follow = (small) =>
    topic && (
      <FollowButton
        kind="topic"
        item={{ slug: topic.slug, title: topic.shortTitle || topic.title }}
        variant="header"
        from="topic_page"
        small={small}
      />
    )
  return (
    <>
      <CollapsingHeader
        title={topic?.title || ''}
        action={follow(false)}
        compactAction={follow(true)}
      />
      {missing ? (
        <NotFoundMessage />
      ) : (
        <SortedFeed
          feed={feed}
          sort={sort}
          setSort={setSort}
          from="topic"
          hideTopic={canonical}
          daySeparators={sort === 'new'}
        />
      )}
    </>
  )
}
